import * as yup from 'yup'

export const loginSchema = yup.object({
    email: yup.string().email('Email must be in a valid format').required('Email is required'),
    password: yup
    .string()
    .required('Password is required')
})

export type LoginUserData = yup.InferType<typeof loginSchema>